import type { FaireProductEntity } from "../../entity_types/product";

export const p_ubz7b6bcp2: FaireProductEntity = {
  token: "p_ubz7b6bcp2",
  type: "product",
  name: "S925 Sterling Silver Simple Double Knot Ring",
  brandToken: "b_9a7m2r54fa",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/fd7674063759f212748afc09d0bfc99cbf25b35664c662ef3f0991f3f4b8bea3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8271b0b42ba4e3d6b7c4a2e092143813252f96aa0f05001403aa8c065c71477a.jpeg",
    "https://cdn.faire.com/fastly/6c8136a00e7c383e97ad1bd7eff2399b5b5ae1edad8b3fc98b3eab05b7b6b9f0.jpeg",
    "https://cdn.faire.com/fastly/dbf07f597fd6581b18ff67d503cee878208e7e75ce3965b6065c1dfd1fae0afd.jpeg",
  ],
  priceDollars: 38.8,
  description:
    "'-ID: GIO-YF-RI2504\n-Material: S925 Sterling Silver White Gold Plated\n-Size: Adjustable\n-Weight(s): 2.39g\n-Quality: Excellent\n-Lead Free, -Nickel Free",
  tags: [],
  msrpDollars: 77.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:38.351Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
